// @flow
import React from 'react';
import { Box } from 'gestalt';

const OUTER_STYLE = {
  backgroundColor: '#efefef',
};

const INNER_STYLE = {
  transition: 'width .4s ease-out',
};

function outerStyle(height, borderRadius) {
  return Object.assign({}, OUTER_STYLE, {
    height: height + 'px',
    borderRadius,
  });
}

function innerStyle(color, progress, borderRadius) {
  return Object.assign({}, INNER_STYLE, {
    backgroundColor: color,
    width: progress + '%',
    borderRadius,
  });
}

type Props = {|
  color?: string,
  height: number,
  progress: number,
  outerBorderRadius?: string,
  innerBorderRadius?: string,
|};

const ProgressBar = ({ color, height, progress, outerBorderRadius, innerBorderRadius }: Props) => (
  <Box
    width="100%"
    overflow="hidden"
    dangerouslySetInlineStyle={{ __style: outerStyle(height, outerBorderRadius) }}
  >
    <Box
      height="inherit"
      dangerouslySetInlineStyle={{ __style: innerStyle(color, progress, innerBorderRadius) }}
    />
  </Box>
);

ProgressBar.defaultProps = {
  color: '#333',
  height: 8,
  progress: 0,
  outerBorderRadius: '10px',
  innerBorderRadius: 'inherit',
};

export default ProgressBar;
